// FORGE Trailer — Launch-Datum aus der Coming-Soon-Config in Text & Aussprache.
// Quelle ist cs_content.launch_date (im CRM gepflegt) — nirgends hartkodiert.

const MON_DE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
const MON_EN = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];
const MON_EN_S = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Ordnungszahlen ausgeschrieben — die Sprachausgabe liest "01.10." sonst als Zahlenreihe vor
const ORD_DE = ['ersten', 'zweiten', 'dritten', 'vierten', 'fünften', 'sechsten', 'siebten', 'achten',
  'neunten', 'zehnten', 'elften', 'zwölften', 'dreizehnten', 'vierzehnten', 'fünfzehnten', 'sechzehnten',
  'siebzehnten', 'achtzehnten', 'neunzehnten', 'zwanzigsten', 'einundzwanzigsten', 'zweiundzwanzigsten',
  'dreiundzwanzigsten', 'vierundzwanzigsten', 'fünfundzwanzigsten', 'sechsundzwanzigsten',
  'siebenundzwanzigsten', 'achtundzwanzigsten', 'neunundzwanzigsten', 'dreißigsten', 'einunddreißigsten'];
const ORD_EN = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth',
  'tenth', 'eleventh', 'twelfth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth',
  'eighteenth', 'nineteenth', 'twentieth', 'twenty-first', 'twenty-second', 'twenty-third',
  'twenty-fourth', 'twenty-fifth', 'twenty-sixth', 'twenty-seventh', 'twenty-eighth', 'twenty-ninth',
  'thirtieth', 'thirty-first'];

// Fallback nur, falls die Supabase-Config nicht erreichbar ist
export const LAUNCH_FALLBACK = '2026-10-01T08:00:00+02:00';

// {launchShort} = 01.10.2026 · {launchName} = 01.10. · {launchSpoken} = "ersten Oktober"
export function launchTokens(launch, lang) {
  const d = launch instanceof Date && !isNaN(launch) ? launch : new Date(LAUNCH_FALLBACK);
  const day = d.getDate(), m = d.getMonth(), y = d.getFullYear();
  if (lang === 'en') return {
    '{launchShort}':  MON_EN_S[m] + ' ' + day + ', ' + y,
    '{launchName}':   MON_EN_S[m] + ' ' + day,
    '{launchSpoken}': MON_EN[m] + ' ' + ORD_EN[day - 1],
  };
  const dd = String(day).padStart(2, '0'), mm = String(m + 1).padStart(2, '0');
  return {
    '{launchShort}':  dd + '.' + mm + '.' + y,
    '{launchName}':   dd + '.' + mm + '.',
    '{launchSpoken}': ORD_DE[day - 1] + ' ' + MON_DE[m],
  };
}

// Ersetzt die Platzhalter in allen Strings eines i18n-Baums (nicht-mutierend)
export function fillLaunch(node, tokens) {
  if (typeof node === 'string') return node.replace(/\{launch(?:Short|Name|Spoken)\}/g, m => tokens[m] ?? m);
  if (Array.isArray(node)) return node.map(v => fillLaunch(v, tokens));
  if (node && typeof node === 'object') {
    const out = {};
    for (const k of Object.keys(node)) out[k] = fillLaunch(node[k], tokens);
    return out;
  }
  return node;
}
